/* ---------------------------------------------------------------------------
(c) 2023-2024, HID Global Corporation, part of ASSA ABLOY.
All rights reserved.

This program is an un published copyrighted work which is proprietary
to HID Global Corporation. This computer program includes Confidential,
Proprietary Information and is a Trade Secret of HID Global Corporation.
Any use, disclosure, modification and/or reproduction is prohibited
unless authorized in writing by HID Global Corporation.

WARNING:  Unauthorized reproduction of this program as well as
unauthorized preparation of derivative works based upon the
program or distribution of copies by sale, rental, lease or
lending are violations of federal copyright laws and state trade
secret laws, punishable by civil and criminal penalties.
--------------------------------------------------------------------------- */
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const canActivate = authService.isAuthenticated();
  return canActivate;
};
